module.exports = "/_next/static/images/ico-location-06c2ca921fc790b927db2e01e65c0920.svg";